import { render, staticRenderFns } from "./ImgBlock.vue?vue&type=template&id=4f05386c&"
import script from "./ImgBlock.vue?vue&type=script&lang=js&"
export * from "./ImgBlock.vue?vue&type=script&lang=js&"
import style0 from "./ImgBlock.vue?vue&type=style&index=0&id=4f05386c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports